import type { IQuizRepository } from '@/core/domain/quiz/IQuizRepository.ts'
import type { Quiz } from '@/core/domain/quiz/Quiz.ts'

export class DeleteQuizVersionUseCase {
  private quizRepository: IQuizRepository

  constructor(quizRepository: IQuizRepository) {
    this.quizRepository = quizRepository
  }

  async execute(quizId: number, versionId: number): Promise<Quiz> {
    // Supprimer la version
    await this.quizRepository.deleteQuizVersion(quizId, versionId)

    // Récupérer le quiz mis à jour
    return await this.quizRepository.fetchQuiz(quizId)
  }
}
